import { render, staticRenderFns } from "./SeeDoctorRecords.vue?vue&type=template&id=ae433dc0&scoped=true&"
import script from "./SeeDoctorRecords.vue?vue&type=script&lang=js&"
export * from "./SeeDoctorRecords.vue?vue&type=script&lang=js&"
import style0 from "./SeeDoctorRecords.vue?vue&type=style&index=0&id=ae433dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae433dc0",
  null
  
)

export default component.exports